export const StyledDropdownShim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: transparent;
`;
import styled from "@emotion/styled";

export const StyledDropdown = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;

export const StyledDropdownToggle = styled.div`
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  transition: background 0.2s;
`;

export const StyledDropdownMenuStyled = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  color: #333;
  min-width: 160px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  margin-top: 0.25rem;
`;

export const StyledDropdownItem = styled.div`
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #f0f0f0;
  }
`;
